import { render, staticRenderFns } from "./withdrawal-list.vue?vue&type=template&id=2c0a0a5d&scoped=true"
import script from "./withdrawal-list.vue?vue&type=script&lang=js"
export * from "./withdrawal-list.vue?vue&type=script&lang=js"
import style0 from "./withdrawal-list.vue?vue&type=style&index=0&id=2c0a0a5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0a0a5d",
  null
  
)

export default component.exports